import { render, staticRenderFns } from "./ForecastSelectRia.vue?vue&type=template&id=22f61579&scoped=true&"
import script from "./ForecastSelectRia.vue?vue&type=script&lang=js&"
export * from "./ForecastSelectRia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f61579",
  null
  
)

export default component.exports